/* SIGHTSS product page — scoped to .sapdp, no framework, no globals beyond one IIFE. */
(function () {
  /* The page is built from separate Shopify sections now, each wrapping its own
     .sapdp, so a single element is no longer the whole page. Query document-wide —
     every class this file touches is namespaced to SIGHTSS anyway. */
  if (!document.querySelector('.sapdp')) return;
  if (window.__sightssPdp) return;   /* every section links this file; run once */
  window.__sightssPdp = true;
  var root = document;

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  var FMT = window.SIGHTSS_MONEY_FORMAT || '€{{amount_with_comma_separator}}';
  function money(cents) {
    var n = (cents || 0) / 100;
    var withComma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withDot = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toLocaleString('nl-NL');
    return FMT
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount\s*\}\}/g, withDot);
  }

  /* ---------- reveal on scroll ---------- */
  var rv = [].slice.call(root.querySelectorAll('.rv'));
  if (!('IntersectionObserver' in window) || reduce) {
    rv.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    rv.forEach(function (el) { io.observe(el); });
  }

  /* ---------- sticky buy bar ----------
     It is moved to <body> on purpose. Inside the section wrapper any ancestor with a
     transform, filter or contain silently turns position:fixed into position:absolute,
     which is what made the bar scroll away instead of staying put. */
  var nav = document.getElementById('pillnav');
  if (nav) {
    [].forEach.call(document.querySelectorAll('.sightss-pillnav'), function (n) {
      if (n !== nav) n.parentNode.removeChild(n);
    });
    if (nav.parentNode !== document.body) document.body.appendChild(nav);
  }

  /* ---------- hero gallery: thumbnails, the next arrow, and click to enlarge ---------- */
  var thumbs = document.getElementById('thumbs');
  var shot = document.getElementById('heroshot');
  var shotNext = document.getElementById('shotnext');
  var tiles = thumbs ? [].slice.call(thumbs.querySelectorAll('.thumb')) : [];

  function show(i) {
    if (!tiles.length || !shot) return;
    i = (i + tiles.length) % tiles.length;
    var b = tiles[i];
    if (!b.dataset.full) return;
    tiles.forEach(function (t) { t.classList.remove('on'); });
    b.classList.add('on');
    var pre = new Image();
    pre.onload = function () {
      shot.src = pre.src;
      shot.removeAttribute('srcset');
      shot.classList.remove('fade');
    };
    shot.classList.add('fade');
    pre.src = b.dataset.full;
  }
  function currentIndex() {
    for (var i = 0; i < tiles.length; i++) { if (tiles[i].classList.contains('on')) return i; }
    return 0;
  }
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.thumb');
      if (b) show(tiles.indexOf(b));
    });
  }
  if (shotNext && tiles.length > 1) {
    shotNext.hidden = false;
    shotNext.addEventListener('click', function () { show(currentIndex() + 1); });
  }

  /* enlarge — the overlay is moved to <body> for the same reason as the buy bar */
  var zoomBtn = document.getElementById('heroshot-btn');
  if (zoomBtn && shot) {
    var zoom = document.createElement('div');
    zoom.className = 'sightss-zoom';
    zoom.hidden = true;
    /* an SVG cross rather than a unicode escape: a literal backslash-u sequence in this
       file gets collapsed on the way to the theme and silently corrupts the asset. */
    zoom.innerHTML = '<button type="button" class="zx" aria-label="Close">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">' +
      '<path d="M2 2 16 16M16 2 2 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '</svg></button><img alt="">';
    document.body.appendChild(zoom);
    var zoomImg = zoom.querySelector('img');
    var openZoom = function () {
      zoomImg.src = shot.currentSrc || shot.src;
      zoomImg.alt = shot.alt || '';
      zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };
    var closeZoom = function () {
      zoom.hidden = true;
      document.documentElement.style.overflow = '';
    };
    zoomBtn.addEventListener('click', openZoom);
    zoom.addEventListener('click', closeZoom);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !zoom.hidden) closeZoom();
    });
  }

  /* ---------- variant picker ---------- */
  var sel = document.getElementById('sightss-variants');
  var atc = document.getElementById('sightss-atc');
  var atcLabel = root.querySelector('[data-atc-label]');
  var atcTotal = root.querySelector('[data-atc-total]');
  var stockEl = document.getElementById('hb-stock');
  var priceEls = [].slice.call(root.querySelectorAll('[data-price]'))
    .concat(nav ? [].slice.call(nav.querySelectorAll('[data-price]')) : []);
  var groups = [].slice.call(root.querySelectorAll('[data-opt-index]'));

  function currentPrice() {
    if (!sel) return 0;
    var o = sel.options[sel.selectedIndex];
    return o ? parseInt(o.dataset.cents || '0', 10) : 0;
  }

  function opts(g) { return [].slice.call(g.querySelectorAll('[data-value]')); }
  function chosen() {
    return groups.map(function (g) {
      var on = g.querySelector('[data-value].on');
      return on ? on.dataset.value : null;
    });
  }

  function syncVariant() {
    if (!sel) return;
    var want = chosen().join(' / ');
    var found = null;
    [].forEach.call(sel.options, function (o) { if (o.textContent.trim() === want) found = o; });
    if (found) { sel.value = found.value; }
    var o = sel.options[sel.selectedIndex];
    var available = o && o.dataset.available === 'true';

    priceEls.forEach(function (el) { if (o && o.dataset.money) el.textContent = o.dataset.money; });

    var wasEl = root.querySelector('[data-was]');
    if (wasEl && o) {
      if (o.dataset.was) { wasEl.textContent = o.dataset.was; wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }

    /* the stock line follows the chosen model — it is read off the variant, never decorative */
    if (stockEl && o) {
      var qty = parseInt(o.dataset.qty || '0', 10);
      var tracked = o.dataset.tracked === '1';
      var thr = parseInt(stockEl.dataset.threshold || '0', 10);
      var state = 'out', word = stockEl.dataset.out;
      if (available) {
        if (tracked && qty > 0 && qty <= thr) {
          state = 'low';
          word = (stockEl.dataset.low || '').replace('[n]', qty);
        } else {
          state = 'in';
          word = stockEl.dataset.in;
        }
      }
      stockEl.className = 'hb-stock ' + state;
      var wEl = stockEl.querySelector('[data-stock-word]');
      if (wEl) wEl.textContent = word;
    }

    if (atc) {
      atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? atc.dataset.add : atc.dataset.soldout;
    }
    groups.forEach(function (g) {
      var i = g.dataset.optIndex;
      var lab = root.querySelector('[data-opt-label="' + i + '"]');
      var on = g.querySelector('[data-value].on');
      if (lab && on) lab.textContent = on.dataset.value;
      /* the label above the control repeats the chosen value, so the answer is
         readable without opening the list */
      var shown = root.querySelector('[data-opt-shown="' + i + '"]');
      if (shown && on) shown.textContent = on.dataset.value;
    });
    syncTotal();
  }

  groups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var c = e.target.closest('[data-value]');
      if (!c || c.disabled) return;
      opts(g).forEach(function (x) {
        x.classList.remove('on');
        if (x.hasAttribute('aria-selected')) x.setAttribute('aria-selected', 'false');
      });
      c.classList.add('on');
      if (c.hasAttribute('aria-selected')) c.setAttribute('aria-selected', 'true');
      closeMenu(g);
      syncVariant();
    });
  });

  /* ---------- the model dropdown ---------- */
  function menuOf(g) { return g.querySelector('[data-mdl-pop]'); }
  function closeMenu(g) {
    var pop = menuOf(g); if (!pop) return;
    pop.hidden = true;
    g.classList.remove('open');
    var b = g.querySelector('[data-mdl-btn]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  function openMenu(g) {
    var pop = menuOf(g); if (!pop) return;
    groups.forEach(function (o) { if (o !== g) closeMenu(o); });
    pop.hidden = false;
    g.classList.add('open');
    var b = g.querySelector('[data-mdl-btn]');
    if (b) b.setAttribute('aria-expanded', 'true');
    var on = pop.querySelector('[data-value].on') || pop.querySelector('[data-value]:not(:disabled)');
    if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest' });
    highlight(g, on);
  }
  function highlight(g, el) {
    var pop = menuOf(g); if (!pop) return;
    [].forEach.call(pop.querySelectorAll('[data-value]'), function (x) { x.classList.remove('hi'); });
    if (el) { el.classList.add('hi'); if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' }); }
  }
  groups.forEach(function (g) {
    var btn = g.querySelector('[data-mdl-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (g.classList.contains('open')) closeMenu(g); else openMenu(g);
    });
    g.addEventListener('keydown', function (e) {
      var pop = menuOf(g);
      if (e.key === 'Escape') { closeMenu(g); btn.focus(); return; }
      if (!pop || pop.hidden) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          if (document.activeElement === btn) { e.preventDefault(); openMenu(g); }
        }
        return;
      }
      var list = [].slice.call(pop.querySelectorAll('[data-value]:not(:disabled)'));
      if (!list.length) return;
      var cur = pop.querySelector('[data-value].hi');
      var i = list.indexOf(cur);
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(g, list[Math.min(list.length - 1, i + 1)] || list[0]); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(g, list[Math.max(0, i - 1)] || list[0]); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (cur) cur.click(); }
    });
  });
  document.addEventListener('click', function (e) {
    groups.forEach(function (g) {
      if (g.querySelector('[data-mdl-btn]') && !g.contains(e.target)) closeMenu(g);
    });
  });

  /* a model with no stock reads as unavailable before you click it */
  if (sel && groups.length === 1) {
    var soldWord = atc ? atc.dataset.soldout : '';
    opts(groups[0]).forEach(function (c) {
      var ok = false;
      [].forEach.call(sel.options, function (o) {
        if (o.textContent.trim() === c.dataset.value && o.dataset.available === 'true') ok = true;
      });
      if (ok) return;
      c.disabled = true;
      var em = c.querySelector('em');
      if (em) em.textContent = soldWord;
    });

    /* What you can actually buy goes first. Twenty greyed-out models above the two live
       ones makes a stocked shop look empty. */
    var pop = groups[0].querySelector('[data-mdl-pop]');
    if (pop) {
      var all = [].slice.call(pop.querySelectorAll('[data-value]'));
      var gone = all.filter(function (x) { return x.disabled; });
      if (gone.length && gone.length < all.length) {
        var rule = document.createElement('div');
        rule.className = 'mdl-rule';
        pop.appendChild(rule);
        gone.forEach(function (x) { pop.appendChild(x); });
      }
    }
  }

  /* ---------- add-on toggles ---------- */
  var addons = [].slice.call(root.querySelectorAll('.ad-cb'));
  function addonTotal() {
    return addons.reduce(function (s, cb) {
      return s + (cb.checked ? parseInt(cb.dataset.addonPrice || '0', 10) : 0);
    }, 0);
  }
  function syncTotal() {
    if (!atcTotal) return;
    var extra = addonTotal();
    atcTotal.textContent = extra > 0 ? money(currentPrice() + extra) : '';
  }
  addons.forEach(function (cb) {
    cb.addEventListener('change', function () {
      var row = cb.closest('.ad');
      if (row) row.classList.toggle('on', cb.checked);
      syncTotal();
    });
  });

  /* ---------- one click, one cart ---------- */
  function cartAdd(items) {
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  var form = document.getElementById('sightss-buy');
  if (form) {
    form.addEventListener('submit', function (e) {
      var extras = addons.filter(function (cb) { return cb.checked; });
      if (!extras.length || !sel) return; /* nothing extra — let the theme handle it */
      e.preventDefault();
      if (atc) atc.disabled = true;
      var qEl = document.getElementById('hb-qty');
      var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      var items = [{ id: parseInt(sel.value, 10), quantity: qty }];
      extras.forEach(function (cb) { items.push({ id: parseInt(cb.dataset.addonId, 10), quantity: 1 }); });
      cartAdd(items).then(function () {
        window.location.href = routes + 'cart';
      }).catch(function () {
        if (atc) atc.disabled = false;
        form.submit();
      });
    });
  }

  /* ---------- upsell cards ---------- */
  [].forEach.call(root.querySelectorAll('.upc-add'), function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('done')) { window.location.href = routes + 'cart'; return; }
      var was = b.textContent;
      b.disabled = true;
      cartAdd([{ id: parseInt(b.dataset.addId, 10), quantity: 1 }]).then(function () {
        b.textContent = b.dataset.added || 'Added';
        b.classList.add('done');
        b.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        b.textContent = was;
        b.disabled = false;
      });
    });
  });

  [].forEach.call(root.querySelectorAll('.upc-notify'), function (b) {
    b.addEventListener('click', function () {
      var box = document.getElementById(b.dataset.notify);
      if (!box) return;
      box.hidden = !box.hidden;
      if (!box.hidden) { var i = box.querySelector('input[type=email]'); if (i) i.focus(); }
    });
  });

  /* ---------- brand film ---------- */
  var vplay = document.getElementById('brandvid-play');
  if (vplay) {
    vplay.addEventListener('click', function () {
      var wrap = document.getElementById('brandvid');
      var v = wrap && wrap.querySelector('video');
      vplay.classList.add('gone');
      if (v) { v.controls = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  /* ---------- carry the chosen model to the privacy product ---------- */
  [].forEach.call(root.querySelectorAll('[data-carry-model]'), function (a) {
    a.addEventListener('click', function () {
      var on = groups.length ? groups[groups.length - 1].querySelector('.chip.on') : null;
      if (on) {
        try {
          var u = new URL(a.href, window.location.origin);
          u.searchParams.set('model', on.dataset.value);
          a.href = u.toString();
        } catch (err) { /* leave the link alone */ }
      }
    });
  });

  /* ---------- FAQ ---------- */
  var faq = document.getElementById('faq-acc');
  if (faq) {
    faq.addEventListener('click', function (e) {
      var b = e.target.closest('.fq-b');
      if (!b) return;
      var item = b.parentNode;
      var open = item.classList.contains('on');
      [].forEach.call(faq.querySelectorAll('.fq'), function (x) { x.classList.remove('on'); });
      if (!open) item.classList.add('on');
    });
  }

  /* ---------- highlights carousel ---------- */
  var rail = document.getElementById('rail');
  var dots = document.getElementById('dots');
  var playb = document.getElementById('playb');
  if (rail) {
    var cards = [].slice.call(rail.children);
    var idx = 0, timer = null;
    var wantsAuto = rail.dataset.autoplay === 'true' && !reduce;

    if (dots) {
      cards.forEach(function (_, i) {
        var d = document.createElement('i');
        if (i === 0) d.className = 'on';
        d.addEventListener('click', function () { go(i); stop(); });
        dots.appendChild(d);
      });
    }
    function paint() {
      if (!dots) return;
      [].forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === idx); });
    }
    function go(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      rail.scrollTo({ left: c.offsetLeft - (rail.clientWidth - c.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      paint();
    }
    function icon(playing) {
      var svg = document.getElementById('playicon');
      if (!svg) return;
      svg.innerHTML = playing
        ? '<rect x="1" y="1" width="3.6" height="12" rx="1"/><rect x="8.4" y="1" width="3.6" height="12" rx="1"/>'
        : '<path d="M2 1.3v11.4c0 .8.9 1.3 1.5.8l8.2-5.7c.6-.4.6-1.2 0-1.6L3.5.5C2.9.1 2 .5 2 1.3z"/>';
      if (playb) playb.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }
    function start() { stop(); timer = setInterval(function () { go(idx + 1); }, 5200); icon(true); }
    function stop() { if (timer) clearInterval(timer); timer = null; icon(false); }

    if (playb) playb.addEventListener('click', function () { timer ? stop() : start(); });

    var st;
    rail.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
          if (d < bd) { bd = d; best = i; }
        });
        idx = best; paint();
      }, 90);
    }, { passive: true });

    icon(false);
    if (wantsAuto) start();
  }

  /* ---------- when the bar appears ---------- */
  if (nav) {
    var anchor = atc || document.getElementById('buy');
    var onScroll = function () {
      if (!anchor) return;
      /* the moment the Add to Bag button leaves the top of the screen, and from then on */
      nav.classList.toggle('show', anchor.getBoundingClientRect().bottom < 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- first paint ---------- */
  syncVariant();
})();
